export enum DoclListEnum{
    partially = 'partially uploaded',
    Full = 'fully uploaded',
    Pending = 'pending',

}

export enum PoStatusEnum{
    Open='Open',
    InProgress='In Progress',
    Closed='Closed'
}